/* src/app/components/account-toolbar/account-toolbar.component.scss */
ion-toolbar {
  padding: 0 12px;
  --background: var(--account-toolbar-background);
  --box-shadow: none;
}
ion-toolbar ion-icon {
  height: 19px;
  width: 19px;
}
ion-toolbar ion-title {
  font-family: AppFont, sans-serif !important;
  text-transform: uppercase;
  color: var(--color-black);
}
/*# sourceMappingURL=account-toolbar.component.css.map */
